export interface FetchClientsQueryParam {
    page: string | number;
    id: string | number;
    fullname: string;
    email: string;
    profile: 'medico' | 'distribuidor' | 'institucion';
    commerce: 'Argentina' | 'COMEX';
    order_by: string;
    order_direction: 'asc' | 'desc';
    per_page: number | string;
}